module.exports = __webpack_public_path__ + "static/img/15.6df384a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/15.jpg
// module id = kOfr
// module chunks = 0